import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csvariable(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# variable tutorial For Beginners</title>
 <meta name="description" content="C# variable tutorial for beginners.variable in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# variable,c# variable for,c sharp variable" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-variable" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C# Variables</h1>
    <div className="first">
        <a href="/csharp-datatypes">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="pt-4 para ">
    1, Variable is the name of a memory location in which we can store the value <br/>
2, The variable value can be changed<br/>
3, A variable is defined by the combination of an identifier, data types, and an initializer.<br/>
4, The first character in the variable name must be an alphabet, underscore, a digit or,
a dollar sign. <br/>
5, All variables have a scope<br/>
6, The identifier is the name of the variable<br/>
 7, Commas or blanks are not used inside a variable name

    </p>
   



<h2 className="headings">C# Variable Declaration Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
          <span className="qwerty-2">Type </span>
            <span className="qwerty-7">Variable Name</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-4">is a Type</span>
            {"\n"}
            <span className="qwerty-10">a,b</span>
            <span className="qwerty-6"> and </span>
            <span className="qwerty-10">ab </span>
            <span className="qwerty-6">are a </span>
            <span className="qwerty-7">Variable Name</span>
              {"\n"} {"\n"}
            
          </code>
        </pre>
      </div>




<h2 className='head3'>C# variable declaration syntax examples:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">Type </span>
            <span className="qwerty-5">Variable Name</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">int </span>
            <span className="qwerty-6">roll_no</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">//this declare a variable</span>
            {"\n"}
            <span className="qwerty-3">float </span>
            <span className="qwerty-4">percentage</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">//this declare a variable</span>
              {"\n"} 
              <span className="qwerty-6">roll_no = </span>
              <span className="qwerty-5">40</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">//assigns a variable a value</span>
              {"\n"} 
              <span className="qwerty-4">precentege = </span>
              <span className="qwerty-5">40.80</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10"> //assigns a variable a value</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2  className="mt-4">Declare a variable in Csharp(C#) Rules:</h2>
<p className="para mt-2">The variable is declared in various types: </p>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-4">abc</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-9">//</span>
            <span className="qwerty-10">this declare a variable</span>
            {"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-4">abc</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-9">//</span>
            <span className="qwerty-10">(abc and a_bc are a variable)</span>
              {"\n"} 
              <span className="qwerty">int </span>
              <span className="qwerty-2">a</span>
              <span className="qwerty-3">, </span>
              <span className="qwerty-2">b</span>
              <span className="qwerty-3">, </span>
              <span className="qwerty-2">x</span>
              <span className="qwerty-3">, </span>
              <span className="qwerty-2">z</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-9">//</span>
            <span className="qwerty-10">(a,b,x,z) are a variable</span>
              {"\n"} 
              <span className="qwerty-7">byte </span>
              <span className="qwerty-2">a</span>
              <span className="qwerty-5">1 </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">40</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-9">//</span>
            <span className="qwerty-10"> initialize a.</span>
            {"\n"} 
              <span className="qwerty-4">double </span>
              <span className="qwerty-2">a</span>
              <span className="qwerty-5">2 </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">40.80</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-9">//</span>
            <span className="qwerty-10"> like a float</span>
            {"\n"} 
              <span className="qwerty-3">char </span>
              <span className="qwerty-2">a</span>
              <span className="qwerty-5">3 </span>
              <span className="qwerty-3">= "</span>
              <span className="qwerty">ram</span>
              <span className="qwerty-3">"; </span>
              <span className="qwerty-9">//</span>
            <span className="qwerty-10"> a variable gain value (ram)</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Addition of variables examples:</h2>



<h2 className='headings'>Q-Declare 3 Variables and Add 3 variables in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-4">namespace</span>
            <span className="qwerty-6">Variable</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty"> class </span>
            <span className="qwerty-6">Variables</span>
            {"\n"}
            <span className="qwerty-3">&#123;</span>
            {"\n"}
            <span className="qwerty-10">  static </span>
            <span className="qwerty-6">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty">(</span>
            <span className="qwerty-10">string </span>
            <span className="qwerty-3">[] </span>
            <span className="qwerty-6">args</span>
            <span className="qwerty">)</span>
            {"\n"}
            <span className="qwerty-3">&#123;</span>
            {"\n"}
            <span className="qwerty">  int </span>
            <span className="qwerty-10">ab</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty">cd</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-3">ef;</span>
            {"\n"}
            <span className="qwerty-10">  ab</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-1">12</span>
            <span className="qwerty-10">; </span>
            <span className="qwerty">cd </span>
            <span className="qwerty">= </span>
            <span className="qwerty-1">24</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-3">ef</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-1">36</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">  Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty"> (</span>
            <span className="qwerty-10">ab </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty">cd </span>
            <span className="qwerty-10">+ </span>
            <span className="qwerty-3">ef</span>
            <span className="qwerty">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"      "}
            <span className="qwerty-3">&#125;</span>
            {"\n"}{"   "}
            <span className="qwerty-3">&#125;</span>
            {"\n"}{" "}
            <span className="qwerty-3">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='head3'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-1"> 72</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className='headings'>Q-Variable increment values in two times?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">10</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-10">// a is a variable and a is a variable</span>
              {"\n"} 
              <span className="qwerty-10">a </span>
              <span className="qwerty-3">+ = </span>
              <span className="qwerty">40</span>
              <span className="qwerty-3">;</span>
              {"\n"} 
              <span className="qwerty-10">a </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-3"> + </span>
              <span className="qwerty">20</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-7">Console</span>
              <span className="qwerty-6">.WriteLine</span>
              <span className="qwerty-2">(</span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-2">)</span>
              <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='head3'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-6"> 70</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>Q-create a variable and store a no inside this variable and print output?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-10">int </span>
            <span className="qwerty">a</span>
            <span className="qwerty-3">;</span>
              {"\n"} 
              <span className="qwerty">a </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-4">40</span>
              <span className="qwerty-3">;</span>
              {"\n"} 
              <span className="qwerty-3">Or</span>
              {"\n"} 
              <span className="qwerty-10">int </span>
              <span className="qwerty">a </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-4">40</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-7">Console</span>
              <span className="qwerty-6">.WriteLine</span>
              <span className="qwerty-2">(</span>
              <span className="qwerty">a</span>
              <span className="qwerty-2">)</span>
              <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4"> 40</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className='headings'>Q-create a string variable and store a no inside string type variable and print output?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-6">Ram</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty">String </span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-5">Lakshman</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-3">Or</span>
              {"\n"}
              <span className="qwerty">String </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">,</span>
              <span className="qwerty-10">b</span>
              <span className="qwerty-10">;</span>
              {"\n"}
              <span className="qwerty-10">a </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-6">Ram</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-10">b </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-5">Lakshman</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-7">Console</span>
              <span className="qwerty-3">.WriteLine</span>
                <span className="qwerty">(</span>
            <span className="qwerty-10">a</span>
              <span className="qwerty-3">+</span>
              <span className="qwerty">" "</span>
              <span className="qwerty-10">+</span>
              <span className="qwerty-3">b</span>
              <span className="qwerty">)</span>
              <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6"> Ram</span>
            <span className="qwerty-5"> Lakshman</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2"> Another string type  example</h2>



<h2 className='headings'>Q-create a string variable and store a no inside string data type variable and print output?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">Class</span>
            <span className="qwerty-7"> Program</span>
            <span className="qwerty-3">&#123;</span>
            {"\n"}
            <span className="qwerty-10">Static</span>
            <span className="qwerty-7"> void </span>
            <span className="qwerty-3"> main </span>
            <span className="qwerty-11">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7"> [] </span>
            <span className="qwerty-3">args</span>
            <span className="qwerty-11">)</span>
            {"\n"}
            <span className="qwerty-3">&#123;</span>
            {"\n"}
            <span className="qwerty-10"> String </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-6">,</span>
            <span className="qwerty-3">b</span>
            <span className="qwerty-6">,</span>
            <span className="qwerty-3">c</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-10"> a </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-6">Ram</span>
            <span className="qwerty-3">";</span>
              {"\n"}
            <span className="qwerty-10"> b </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-5">Lakshman</span>
            <span className="qwerty-3">";</span>
              {"\n"}
            <span className="qwerty-10"> c </span>
            <span className="qwerty-3">=</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-10">My Name is CodeExampler</span>
              <span className="qwerty-3"></span>
            <span className="qwerty-4"> 160208</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-7"> Console</span>
              <span className="qwerty-6">.WriteLine </span>
              <span className="qwerty-3">(</span>
       
            <span className="qwerty-10">a </span>
            <span className="qwerty">+</span>
              <span className="qwerty-3">" " </span>
              <span className="qwerty">+</span>
              <span className="qwerty-10">b </span>
              <span className="qwerty">+</span>
              <span className="qwerty-3">" " </span>
              <span className="qwerty">+</span>
              <span className="qwerty-10">c</span>
              <span className="qwerty-3">);</span>
              {"\n"}
              <span className="qwerty-3">&#125;</span>
            {"\n"}
            <span className="qwerty-3">&#125;</span>
            {"\n"}
            <span className="qwerty-3">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='head3'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-6"> Ram</span>
            <span className="qwerty-5"> Lakshman</span>
            <span className="qwerty-10"> My Name is CodeExampler</span>
            <span className="qwerty-4"> 160208</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Constant:</h2>

<p className="para mt-4">Constant is use when if you store  a value inside a variable 
    but after you can’t overwrite existing value so on that place use constant.
</p>


  <h1 className="mt-5">  </h1>
      <h1 className="mt-5">  </h1>
     
      <div className="back">
        <a href="/csharp-datatypes">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csvariable;